export default __webpack_public_path__ + "static/sh-hl-7ba1be5f76c5a229d21a0341e17dcfb0.svg";